module.exports = __webpack_public_path__ + "img/1521337291.d80c5636.jpg";